import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { absUrl } from "./media";

// Standalone render of one Welcome Tour card (used by the admin editor at /admin/welcome-tour and if dropped on a page).
const TourCardBlock = ({ block }) => {
  const cfg = block.config || {};
  const accent = cfg.accent || "#F2CC8F";
  const bullets = (cfg.bullets || "").split("\n").map((s) => s.trim()).filter(Boolean);
  return (
    <section className="max-w-3xl mx-auto px-6 py-4" data-testid={`tour-card-block-${block.block_id}`}>
      <div className="rounded-2xl bg-[#0F1A22] text-white border border-white/10 p-5 flex gap-4">
        <div className="h-24 w-24 rounded-xl overflow-hidden shrink-0 bg-white ring-2" style={{ "--tw-ring-color": accent }}>
          {cfg.image && <img src={absUrl(cfg.image)} alt="" className="h-full w-full object-cover" />}
        </div>
        <div className="min-w-0 flex-1">
          {cfg.eyebrow && <p className="text-[10px] font-bold uppercase tracking-[0.2em]" style={{ color: accent }}>{cfg.eyebrow}</p>}
          <h3 className="font-['Playfair_Display'] text-2xl leading-tight">{block.title}</h3>
          <p className="text-sm text-white/85 mt-1">{block.quip}</p>
          {cfg.body && <p className="text-sm text-white/70 mt-2">{cfg.body}</p>}
          {bullets.length > 0 && <ul className="mt-2 space-y-1">{bullets.map((b) => <li key={b} className="flex gap-2 text-sm text-white/85"><span className="mt-2 h-1.5 w-1.5 rounded-full shrink-0" style={{ backgroundColor: accent }} />{b}</li>)}</ul>}
          {cfg.cta_label && <Link to={cfg.cta_route || "/"} className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 mt-3 font-bold text-[#0F1A22]" style={{ backgroundColor: accent }}>{cfg.cta_label} <ArrowRight className="h-4 w-4" /></Link>}
        </div>
      </div>
    </section>
  );
};

export default TourCardBlock;
